import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  () => ({
    btnMain: {
      alignItems: "center",
      height: 48,
      padding: "12px 36px",
      "& .MuiButton-label": {
        fontWeight: 700,
        fontSize: 14
      },
      backgroundColor: "#000000"
    }
  }),
  { name: "DownloadExcelTemplate" }
);

export default useStyles;
